Object.defineProperty(exports, "__esModule", { value: true });
var formatter_1 = require("../layout/formatter");
var LogAppender = /** @class */ (function () {
    function LogAppender(config) {
        // do nothing
    }
    /**
     * Returns whether or not the appender is active
     * @returns {boolean}
     */
    LogAppender.prototype.isActive = function () {
        return this.active === true;
    };
    /**
     * Appends the log
     * @param {ILogEvent} logEvent
     */
    LogAppender.prototype.append = function (logEvent) {
        // stub
    };
    /**
     * Gets the current log level
     * @returns {number}
     */
    LogAppender.prototype.getLogLevel = function () {
        return this.logLevel;
    };
    /**
     * Sets the log level of the appender
     * @param {LogLevel} logLevel
     */
    LogAppender.prototype.setLogLevel = function (logLevel) {
        this.logLevel = logLevel;
    };
    /**
     * Sets the layout of the appender
     * @param {string} layout
     */
    LogAppender.prototype.setLayout = function (layout) {
        this.layout = layout;
    };
    /**
     * Gets the layout associated with the appender
     * @returns {string}
     */
    LogAppender.prototype.getLayout = function () {
        return this.layout;
    };
    /**
     * Formats the log event using the layout provided
     * @param {ILogEvent} logEvent
     */
    LogAppender.prototype.format = function (logEvent) {
        return formatter_1.format(this.getLayout(), logEvent);
    };
    return LogAppender;
}());
exports.LogAppender = LogAppender;
